import { DSText } from '@engenharia/ds-react';
import styled from 'styled-components';
import spaces from '../../../styles/theme/spaces';
import colors from '../../../styles/theme/colors';
import { sizes } from '../../../styles/theme/devices';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  overflow: auto;

  header {
    position: sticky;
    top: 0;
  }

  footer {
    position: sticky;
  }
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 ${spaces.small};
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;
  max-width: 605px;
  padding: ${spaces.extraLarge} ${spaces.medium};
  border: 2px solid ${colors.primary.main};
  border-radius: 16px;
  background: ${colors.primary.light};

  @media (min-width: ${sizes.tablet}) {
    padding: ${spaces.large};
  }
`;

const FormInput = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;

  width: 100%;
`;

const Heading = styled(DSText)`
  color: ${colors.primary.main};
  font-weight: 600;
  margin-top: ${spaces.small};
  text-align: center;
  font-size: 20px;
`;

const HeadingSubtitle = styled(DSText)`
  color: ${colors.gray[500]};
  font-weight: 400;
  margin-top: ${spaces.micro};
  margin-bottom: ${spaces.small};
  text-align: center;
  font-size: 14px;
`;

const DescriptionText = styled(DSText)`
  text-align: center;
  color: ${colors.default.gray};
  font-size: 14px;
  padding: 0;

  @media (min-width: ${sizes.tablet}) {
    padding: 0 20px;
  }
`;

const ContainerRadio = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  margin-top 8px;
`;

const CounterRadio = styled.div`
  display: flex;
  height: 24px;
  width: 24px;
  border-radius: 50%;
  border: 2px solid #e0e0e0;
  position: relative;

  ${({ isChecked }) =>
    isChecked &&
    `
    border-color: ${colors.primary.main};
    
    &::before {
      content: '';
      width: 12px;
      height: 12px;
      background: ${colors.primary.main};
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      z-index: 200;
      border-radius: 50%;    
    }`}
`;

const CounterLabel = styled.div`
  align-items: center;
  background-color: ${colors.gray[50]};
  border-radius: 0 0 6px 6px;
  display: flex;
  height: 37px;
  justify-content: center;
  width: 100%;

  p {
    color: ${colors.gray[500]};
  }
`;

const Counter = styled.div`
  align-items: center;
  justify-content: space-between;
  background-color: ${colors.default.white};
  border: 2px solid ${(props) => (props.isChecked ? colors.primary.main : colors.gray[100])};
  border-radius: 8px;
  color: ${(props) => (props.isChecked ? colors.default.white : colors.gray[500])};
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 117px;
  height: 117px;
  cursor: pointer;
  gap: 16px;

  ${({ isChecked }) =>
    isChecked &&
    `${CounterLabel} {
    background-color: ${colors.primary.main};
    p {
      color: ${colors.default.white};
    }
  }`}

  &:hover {
    border: 2px solid ${colors.primary.main};
    border-radius: 8px;
    color: ${colors.default.white};

    ${CounterLabel} {
      background-color: ${colors.primary.main};
      p {
        color: ${colors.default.white};
      }
    }

    ${CounterRadio} {
      border-color: ${colors.primary.main};
    }
  }

  input[type='number'] {
    -moz-appearance: textfield;
    background-color: ${colors.default.white};
    border: 0;
    color: ${colors.default.gray};
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 500;
    height: 32px;
    margin: 16px auto;

    line-height: 1;
    text-align: center;
    width: 85px;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

const CounterOption = styled(DSText)`
  color: ${colors.gray[700]};
  font-size: 24px;
  font-weight: 500;
  padding: 0;
  text-align: center;
`;

export {
  Box,
  Container,
  Content,
  Counter,
  CounterLabel,
  DescriptionText,
  Heading,
  FormInput,
  HeadingSubtitle,
  CounterOption,
  CounterRadio,
  ContainerRadio,
};
